'use strict';

angular.module('amexReconciliationApp')
  .component('userPreferencesModal', {
    templateUrl: 'scripts/views/components/user-preferences-modal.html',
    bindings: {
      closeModalCallback: '&'
    },
    controller: function (languages,
                          dateFormats,
                          currencyFormats,
                          UserModel,
                          toastr,
                          $translate,
                          FeatureFlagModel,
                          UserPreferencesRepository,
                          $window) {
      var self = this;
      self.displayLanguageSelection = FeatureFlagModel.languageFlag;

      self.closeModal = self.closeModalCallback;

      self.languages = languages;
      self.dateFormats = _.keys(dateFormats);
      self.currencyFormats = currencyFormats;
      self.emailValid=true;
      self.errorMessage=$translate.instant('oneIdentity.enterValidEmail');
      var currentPreferences = UserModel.currentUserPreferences();
      self.selectedLanguage = currentPreferences.language;
      self.selectedDateFormat = currentPreferences.dateFormat;
      self.selectedCurrencyFormat = currentPreferences.currencyFormat;
      self.selectedEmail = currentPreferences.email;
      self.userMigrationStatusCode = currentPreferences.userMigrationStatusCode;
      const two_step_verification_url= '/account/two-step-verification/' +
            'manage?linknav=US-Ser-axpAccountManagement-ManageTwoStepVerification';
      const langMap={
          'EN_AU': 'en-au',
          'EN_CA': 'en-ca',
          'FR_CA': 'fr-ca',
          'EN_GB': 'en-gb',
          'EN_US': 'en-us',
          'ES_ES': 'es-es',
          'PT_BR': 'pt-br',
          'FR_FR': 'fr-fr',
          'DE_DE': 'de-de',
          'SV_SE': 'sv-se',
          'NL_NL': 'nl-nl',
          'ES_LA': 'es-mx',
          'IT_IT': 'it-it'
      };



      self.save = function () {

        var userPreferences = UserModel.currentUserPreferences();
        userPreferences.language = self.selectedLanguage;
        userPreferences.dateFormat = self.selectedDateFormat;
        userPreferences.currencyFormat = self.selectedCurrencyFormat;
        userPreferences.email = self.selectedEmail;

        UserPreferencesRepository.save(userPreferences)
          .then(function () {
            UserModel.currentUser().preferredLanguage = self.selectedLanguage;
            UserModel.currentUser().preferredDateFormat = self.selectedDateFormat;
            UserModel.currentUser().preferredCurrencyFormat = self.selectedCurrencyFormat;
            UserModel.currentUser().preferredEmail = self.selectedEmail;
            $window.location.reload();
          }).catch(function (response) {
            saveChangesFailure(response);
        } );
      };

        function saveChangesFailure(response) {
            if (response.status === 406) {
                self.emailValid = false;
                self.errorMessage = response.data.email;
                if(self.errorMessage=='inValidEmail'){
                    self.errorMessage=$translate.instant('oneIdentity.enterValidEmail');
                }
            }else{
                toastr.error($translate.instant('oneIdentity.SaveError'));
            }
        }

      function urls() {
        return {
            e1: {
                domain: 'https://identity-1-dev.americanexpress.com/'
            },
            e2: {
                domain: 'https://identity-1-qa.americanexpress.com/'
            },
            e3: {
                domain: 'https://www.americanexpress.com/'
            }
        };
      }
        function getLanguageMapping() {
            return currentPreferences.language in langMap ? langMap[currentPreferences.language] :'en-us';
        }

      function getTwoStepVerificationUrl() {
        const host = `${window.location.hostname}`;
        let loggedInEnvironment = 'e3';
        if (host.includes('local') || host.includes('dev')) {
            loggedInEnvironment = 'e1';
        }
        if (host.includes('qa')) {
            loggedInEnvironment = 'e2';
        }
        return urls()[loggedInEnvironment]['domain']+getLanguageMapping()+two_step_verification_url;
      }

     self.isUserEligible = function () {
         return (self.userMigrationStatusCode==='MGRTD' || self.userMigrationStatusCode=== 'EIDRC');
     };

      self.validateEmail = function (){
          if(self.selectedEmail){
              let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
              self.emailValid = emailPattern.test(self.selectedEmail);
          }
          else {
              self.emailValid=false;
          }
      };

      self.triggerIdentityManagement = function () {
          self.closeModal();
        if(window.AmexSession) {
        window.AmexSession.options({
            locale: getLanguageMapping()
        });
         window.AmexSession.identityManagementCenter({
           autoClose: true, // iframe will be closed in imcHandler by AmexSession.closeSessionFrame();
           callback: function ({statusCode, error}) {
             console.log(`statusCode: ${statusCode},error: ${error}`);
             if(error){
                 toastr.error('Error displaying Identity Management Center');
             }
             window.AmexSession.closeSessionFrame();
           },
           hiddenSections: {
             mobileNumberSection: true,
             governmentIdentitySection: true
           }
         });
       }
        else {
            toastr.error('Error displaying Identity Management Center');
        }
      };

      self.openManageTwoStepVerificationInNewTab = function () {
        const url = getTwoStepVerificationUrl();
        window.open(url, '_blank');
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/userPreferencesModal.js
// module id = 506
// module chunks = 0